// {new-country-onboarding} Add new timezones here
const timezones = [
  { id: 'Europe/Copenhagen', name: 'Europe/Copenhagen' },
  { id: 'Europe/Helsinki', name: 'Europe/Helsinki' },
  { id: 'Europe/Lisbon', name: 'Europe/Lisbon' },
  { id: 'Europe/London', name: 'Europe/London' },
  { id: 'Europe/Madrid', name: 'Europe/Madrid' },
  { id: 'Europe/Oslo', name: 'Europe/Oslo' },
  { id: 'Europe/Stockholm', name: 'Europe/Stockholm' },
  { id: 'Europe/Istanbul', name: 'Europe/Istanbul' },
  // { id: 'Asia/Dubai', name: 'Asia/Dubai' },
];

export default timezones;
